/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

/**
 *
 * @param milliseconds
 * @returns {Promise<unknown>}
 * @since 3.55.0
 * @memberOf Monster.Util
 */
export function Sleep(milliseconds) {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
